import React from "react";
import axios from "axios";
import { api } from "./api/client";
import MUIDataTable from "mui-datatables";
import { CircularProgress, Box, TextField } from "@mui/material";
import './App.css';
import {utils, write} from "xlsx";
import { saveAs } from 'file-saver'
import {adaptV4Theme, createTheme, ThemeProvider} from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MalzemeListesiOnizleme from "./MalzemeListesiOnizleme";
import {Paper} from "@material-ui/core";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";
class TeklifSatisRaporuChild extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            veriler: [],
            yukleniyor: true,
            mal:0,
            hizmet:0
        };
    }

    componentDidMount() {
        this.veriGetir();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.yil !== this.state.yil) {
            this.veriGetir();
        }
        console.log(prevProps.rowData);
    }

    veriGetir = () => {
        this.setState({ yukleniyor: true });

        api.get(`/raporlar/teklif-satis/child/${encodeURIComponent(this.props.teklifNo)}`)
            .then(res => {
                try {
                    const liste = Array.isArray(res.data.liste) ? res.data.liste : [];
                    console.log("Liste uzunluğu:", liste.length);
                    console.log("Bozuklar:", liste.filter(d => !d || typeof d !== "object"));
                    const temiz = liste
                        .filter(d => d && typeof d === "object") // null veya bozuk öğeleri at
                        .map(d => ({
                            urun_adi: d?.urun_adi ?? "",
                            adet: d?.adet ? parseInt(d.adet) : 0,
                            fiyat: d?.fiyat ? parseFloat(d.fiyat) : 0,
                            doviz: d?.doviz ?? "",
                            musteri: d?.musteri ?? "",
                            maliyet_carpani:d?.maliyet_carpani ?? "",
                            sevk_tarihi: d?.sevk_tarihi
                                ? new Date(d.sevk_tarihi).toLocaleDateString("tr-TR")
                                : "",
                            fiyat_euro: d?.fiyat_euro ? parseFloat(d.fiyat_euro) : 0
                        }));
                    this.setState({ veriler: temiz, yukleniyor: false});

                } catch (mapError) {
                    console.error("Veri map sırasında patladı:", mapError);
                    this.setState({ veriler: [], yukleniyor: false });
                }
            })
            .catch(err => {
                console.error("Veri alınamadı:", err.message);
                this.setState({ yukleniyor: false });
            });
    };

    yilDegisti = (e) => {
        this.setState({ yil: e.target.value });
    };

    render() {
        const options = {
            filter: true,
            onFilterChange: (changedColumn, filterList) => {
                console.log(changedColumn, filterList);
            },
            selectableRows: 'none',
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '80%',
            print:false,
            download:true,
            searchOpen:false,
            draggableColumns: {
                enabled:true,
                transitionTime:400
            },
            rowStyle: {
                fontSize: 9,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },

            textLabels :{
                body: {
                    noMatch: "Bu tabloda hiç bir veri yok",
                    toolTip: "Sırala",
                    columnHeaderTooltip: column => `${column.label} için sırala`
                },
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Tamamlanan Teklifler Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },

        };
        const myTheme  = createTheme(adaptV4Theme({
            overrides: {

                MUIDataTableHead:{
                    root:{
                        lineHeight:0.5,
                        maxHeight:"10px",
                        padding:0
                    }
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 1,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:1
                    }
                },


            },
        }));
        function kisaltMusteriAdi(ad) {
            const kelimeler = ad.trim().split(" ");
            return kelimeler.slice(0, 2).join(" ");
        }
        const kolonlar = [

            { name: "urun_adi", label: "Ürün Adı" },
            { name: "adet", label: "Adet" },
            { name: "maliyet_carpani", label: "Maliyet Ç." },
            { name: "fiyat", label: "Fiyat",
                options: {
                    customBodyRender: (value) =>
                        value?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })
                }},
            { name: "doviz", label: "P. Birimi" },
            {
                name: "fiyat_euro",
                label: "Fiyat Euro (€)",
                options: {
                    customBodyRender: (value) =>
                        value?.toLocaleString("tr-TR", { minimumFractionDigits: 2 })
                }
            }
        ];

        return (
            <Box sx={{ width: '100%' }}>
                <Paper sx={{ width: '100%', margin: 0, padding: 1 }}>

                {this.state.yukleniyor ? (
                    <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <ThemeProvider theme={myTheme}>

                    <MUIDataTable
                        data={this.state.veriler}
                        columns={enhanceColumns(kolonlar)}
                        options={withTableOptions(options)}
                    />
                    </ThemeProvider>
                )}
                </Paper>
            </Box>
        );
    }
}

export default TeklifSatisRaporuChild;